module.exports = __webpack_public_path__ + "img/gratiaimage2.d50eab57.jpg";